var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"min-h-screen bg-slate-900 py-4 text-slate-200 flex flex-col px-4 md:px-0",attrs:{"id":"app"}},[(_vm.currentRoutePath == '/')?_c('AddNote'):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }